'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoJersey = function GoJersey(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 0h-7.5c0 1.3-1.3 2.5-3.8 2.5s-3.7-1.2-3.7-2.5h-7.5c0 5-0.1 15-5 15 0 0 0 21.3 0 22.5s1.2 2.5 2.5 2.5h27.5s2.5-1.2 2.5-2.5v-22.5c-5 0-5-10-5-15z m-23.8 37.5c-0.6 0-1.2-0.4-1.2-1.2v-18.8c4.6-2.5 5-7.5 5-15h2.5c0 3.8 1.3 7.5 6.3 7.5s6.2-3.7 6.2-7.5h2.5c0 7.3 1.3 10.8 2.5 13.2v21.8h-23.8z m15.1-22.5l-1.3 1.3v12.5l1.3 1.2h5l1.2-1.2v-12.5l-1.2-1.3h-5z m3.7 12.5h-2.5v-10h2.5v10z m-13.7-12.5l-1.3 1.3v12.5l1.3 1.2h5l1.2-1.2v-12.5l-1.2-1.3h-5z m3.7 12.5h-2.5v-10h2.5v10z' })
        )
    );
};

exports.default = GoJersey;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/jersey.js
// module id = 1943
// module chunks = 0